









// @ is an alias to /src
import TitleBar from '@/modules/core/components/TitleBar.vue';
import TagEdit from '../components/TagEdit.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    TagEdit,
  },
})
export default class TagEditPage extends Vue {
  public get titleStack(): string[] {
    return ['Admin', this.tagId ? 'Edition de tag' : 'Nouveau tag'];
  }

  public get tagId(): string {
    return this.$router.currentRoute.params.id;
  }

  public goBack(): void {
    this.$router.go(-1);
  }
  public tagEdited(): void {
    this.goBack();
  }
}
